import { defineNuxtPlugin } from '#app'
import { useHistoryNavigation } from '~/composables/useHistoryNavigation'

export default defineNuxtPlugin(nuxtApp => {
  // Initialize only on client-side
  if (process.client) {
    const { provideHistoryNavigation, isHistoryBack } = useHistoryNavigation()
    
    // Initialize the history navigation state
    provideHistoryNavigation()
    
    // Make it available globally via the Nuxt context
    nuxtApp.provide('isHistoryBack', isHistoryBack)
  }
}) 